export default __webpack_public_path__ + "static/img2@2x-a80f85a36dea8060f4611bb7581222df.jpg";